import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

type onClose = (onClose: () => void) => JSX.Element;

interface Props {
  children: JSX.Element | onClose;
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  maxWidth?: 'lg' | 'xl';
  actions?: JSX.Element | JSX.Element[] | onClose;
}

const Modal = (props: Props) => {
  const { children, title, isOpen, onClose, maxWidth, actions } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      fullWidth
      maxWidth={maxWidth}
    >
      {props.title ? <DialogTitle>{title}</DialogTitle> : null}
      <DialogContent>{typeof children === 'function' ? children(onClose) : children}</DialogContent>
      {actions && <DialogActions>{typeof actions === 'function' ? actions(onClose) : actions}</DialogActions>}
    </Dialog>
  );
};

export default Modal;
